import {AbstractDeviceConsumablePricingItem} from "./abstract-device-consumable-pricing-item";

export class DeviceConsumablePricingItem extends AbstractDeviceConsumablePricingItem {
}
